import React from "react";
import { Link } from "react-router-dom";
import ModernHeader from "../modern/ModernHeader";
import { Footer } from "../general";
import Img404 from "../../images/mensaje.jpg";

const Error404 = () => {
  return (
    <>
      <ModernHeader />

      <main className="modern-404-page">
        <section className="modern-404-hero">
          <div className="auto-container">
            <div className="modern-404-grid">
              <div className="modern-404-content">
                <h1 className="error-code">404</h1>
                <h2 className="error-title">Página no encontrada</h2>
                <p className="error-desc">
                  Lo sentimos — la página que buscas no existe o fue movida.
                  Revisa la URL o vuelve al inicio para continuar navegando.
                </p>

                <div className="error-ctas">
                  <Link to="/" className="btn-modern btn-modern-primary">
                    Volver al inicio
                  </Link>

                  <Link
                    to="/contacto"
                    className="btn-modern btn-modern-secondary"
                    aria-label="Contactar soporte"
                  >
                    Contactar
                  </Link>
                </div>
              </div>

              <div className="modern-404-media" aria-hidden="true">
                <img src={Img404} alt="Ilustración página no encontrada" />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Error404;
